import React, { memo } from 'react';
import cn from 'classnames';
import { Tooltip } from 'ksnm-common-ui/lib/Tooltip';
import type { CSSProperties, ReactElement } from 'react';

import { ValueWithCopy } from '../ValueWithCopy';

import styles from './Row.module.scss';

interface IRow {
  name: string | ReactElement;
  // Если в value ReactElement надо вручную навешивать на этот элемент
  // overflow: hidden и text-overflow: ellipsis для отображения многоточия
  value?: string | number | ReactElement;
  className?: string;
  valueClassName?: string;
  withCopy?: boolean;
  needOverflow?: boolean;
  withTooltip?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
  nameWidth?: number;
}

export const Row = memo(
  ({
    name,
    value,
    className,
    withCopy,
    needOverflow = false,
    withTooltip = false,
    onClick,
    style,
    nameWidth,
  }: IRow): ReactElement => {
    const val = value || '------------------';
    const valueWithCopyOverflow = withCopy && needOverflow;

    return (
      <div className={cn(styles.row, className, { [styles.hiddenTextBlock]: needOverflow })} style={style}>
        <div className={styles.name} style={{ width: nameWidth, minWidth: nameWidth }}>
          {name}
        </div>

        <Tooltip content={valueWithCopyOverflow || !withTooltip ? undefined : value}>
          <div
            onClick={onClick}
            className={cn(
              styles.value,
              {
                [styles.hiddenText]: !withCopy && needOverflow,
                [styles.hiddenTextBlock]: valueWithCopyOverflow,
                [styles.cursor]: onClick,
              },
              '___row_value',
            )}
          >
            {withCopy ? <ValueWithCopy needOverflow={needOverflow}>{val}</ValueWithCopy> : val}
          </div>
        </Tooltip>
      </div>
    );
  },
);
